<template>
  <nav id="navbar" class="flex border-b border-gray-400 inset-x-0 items-center py-2 bg-white shadow px-5 md:px-0">
    <div class="w-full max-w-screen-xl relative mx-auto">
      <div class="flex items-center justify-between">
        <div class="flex items-center lg:mr-4 py-2">
          <router-link :to="`/${studioDetails.webUrl}`">
            <img :src="studioDetails.logoUrl" class="m-w-100 h-12" alt="Miller's Online Marketplace" />
          </router-link>
        </div>

        <div class="w-full flex-grow sm:flex items-center sm:w-auto ml-8 sm:items-center navbar-links">
          <div class="text-md sm:flex-grow smOnly:pb-4">
            <div class="flex text-right">
              <div class="flex-grow primary-500 items-center flex">
                <!-- For links that should be near the logo -->
              </div>
              <div v-if="cart && cart.numberOfItems > 0" class="flex items-center">
                <router-link :to="`/${studioDetails.webUrl}/cart`" class="text-gray-900">
                  <div class="flex items-center p-3">
                    <p class="font-bold text-lg">
                      {{ cart.numberOfItems }}
                    </p>
                    <d-icon icon="shopping-cart" class="ml-2" size="lg" />
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
  import { mapState, mapActions } from 'pinia';
  import { defineComponent } from 'vue';
  import { useCartStore } from '@resources/scripts/store/cart.store';
  import { useStudioStore } from '@resources/scripts/store/studio.store';

  export default defineComponent({
    computed: {
      ...mapState(useCartStore, {
        cart: 'basicCartData',
      }),
      ...mapState(useStudioStore, {
        studioDetails: 'studioDetails',
      }),
    },

    mounted() {
      this.fetchCartDetails();
      this.loadStudioDetails(window.studioDetails);
    },

    methods: {
      ...mapActions(useCartStore, {
        fetchCartDetails: 'loadBasicData',
      }),
      ...mapActions(useStudioStore, {
        loadStudioDetails: 'loadStudioDetails',
      }),
    },
  });
</script>
